import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import useWindowSize from 'components/hooks/useWindowSize'
import useMediaQuerySize from 'components/hooks/useMediaQuerySize'

import {
  TOOLBAR_OFFSET,
  ALERT_OFFSET,
  FLOATING_SIDEBAR_OFFSET,
  FLOATING_SIDEBAR_WIDTH,
} from 'settings'

const useStyles = makeStyles(theme => ({
  root: ({
    screenSize,
  }) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: screenSize == 'large' ? 'row' : 'column',
  }),
  sidebar: ({
    toolbarOffset,
    sidebarOffset,
    sidebarWidth,
    screenSize,
    windowSize,
    withAlert,
  }) => {
    
    const css = {
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(2),
      marginRight: theme.spacing(2),
      flexGrow: 0,
      width: '100%',      
    }

    if(screenSize == 'large') {
      const height = windowSize.height - toolbarOffset - sidebarOffset - (withAlert ? ALERT_OFFSET : 0)
      css.maxHeight = `${height}px`
      css.overflowY = 'auto'
      css.position = 'fixed'
      css.width = `${sidebarWidth}px`
      css.maxWidth = `${sidebarWidth}px`
    }
    else {
      css.marginBottom = theme.spacing(2)
    }

    return css
  },
  content: ({
    screenSize,
    sidebarWidth,
  }) => ({
    flexGrow: 1,
    marginLeft: screenSize == 'large' ?
      `${sidebarWidth + theme.spacing(2)}px` : 
      '0px',
  }),
}))

const FloatingSidebar = ({
  toolbarOffset = TOOLBAR_OFFSET,
  sidebarOffset = FLOATING_SIDEBAR_OFFSET,
  sidebarWidth = FLOATING_SIDEBAR_WIDTH,
  withAlert = false,
  sidebar,
  children,
}) => {

  const windowSize = useWindowSize()
  const screenSize = useMediaQuerySize()
  
  const classes = useStyles({
    toolbarOffset,
    sidebarOffset,
    sidebarWidth,
    screenSize,
    windowSize,
    withAlert,
  })

  return (
    <div className={ classes.root }>
      <div className={ classes.sidebar }>
        { sidebar }
      </div>
      <div className={ classes.content }>
        { children }
      </div>
    </div>
  )
}
export default FloatingSidebar